import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import { API, BACKEND_HOST } from '../../../api';
import Select from 'react-select';
import { SITE_ID, SUBDOMAIN } from '../../../assets/meta/meta';
import moment from 'moment';
import { Button } from '@/Components/ui';
import { dialogService } from "@/utils/dialogService";
import { useUnsavedChangesGuard } from '@/hooks/useUnsavedChangesGuard';
const CouponBookForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [couponProducts, setCouponProducts] = React.useState([]);
    const [selectedCouponProduct, setSelectedCouponProduct] = React.useState(null);
    const [startDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());
    const [couponState, setCouponState] = React.useState("노출중");
    const [couponCount, setCouponCount] = React.useState(1);
    const [type, setType] = React.useState("event");
    const [usageAmount, setUsageAmount] = React.useState(0);
    const [usagePeriod, setUsagePeriod] = React.useState(30);
    const [eventSites, setEventSites] = React.useState([]);
    const [selectedEventSites, setSelectedEventSites] = React.useState([{ value: SITE_ID, label: SUBDOMAIN }]);
    const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
    const markDirty = React.useCallback(() => setHasUnsavedChanges(true), []);
    const { confirmDiscardChanges } = useUnsavedChangesGuard({
        isDirty: hasUnsavedChanges,
        confirmNavigation: dialogService.confirm,
    });
    React.useEffect(() => {
        if (id && id !== '0') {
            API.get(`${BACKEND_HOST}/coupon/rules/${id}/`)
                .then(res => {
                fillStates(res.data);
            })
                .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        }
    }, [id]);
    React.useEffect(() => {
        API.get(`${BACKEND_HOST}/coupon/products?include_hidden=true`)
            .then(res => {
            setCouponProducts(res.data.map((item) => { return { value: item.id, label: item.title }; }));
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        API.get(`${BACKEND_HOST}/sites/camps/`)
            .then(res => {
            setEventSites(res.data.map((item) => { return { value: item.id, label: item.name }; }));
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    }, []);
    const fillStates = (data) => {
        setSelectedCouponProduct({ value: data.coupon_product.id, label: data.coupon_product.title });
        setStartDate(data.start_date);
        setEndDate(data.end_date);
        setCouponState(data.state);
        setCouponCount(data.stock);
        setType(data.type);
        setUsageAmount(data.usage_amount);
        setUsagePeriod(data.usage_period_day);
        setSelectedEventSites(data.target_sites?.map((item) => { return { value: item.id, label: item.name }; }));
    };
    const sendData = async (e) => {
        const data = await checkData(true);
        if (data === null)
            return;
        API.post(`${BACKEND_HOST}/coupon/rules/`, data)
            .then(async (res) => {
            console.log("sendData", res.data);
            setHasUnsavedChanges(false);
            await dialogService.handleAlert("post ok");
            navigate(`/couponbook-list`);
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    const updateData = async (e) => {
        const data = await checkData(false);
        if (data === null)
            return;
        API.put(`${BACKEND_HOST}/coupon/rules/${id}/`, data)
            .then(async (res) => {
            console.log("updateData", res.data);
            setHasUnsavedChanges(false);
            await dialogService.handleAlert("update ok");
            navigate(`/couponbook-list`);
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    const checkData = async (isNew = false) => {
        if (selectedCouponProduct === null) {
            await dialogService.handleAlert("쿠폰 상품을 선택해주세요.");
            return null;
        }
        if (selectedEventSites.length === 0) {
            await dialogService.handleAlert("대상 사이트를 선택해주세요.");
            return null;
        }
        let data = {
            "coupon_product": selectedCouponProduct.value,
            "start_date": moment(new Date(startDate)).format("YYYY-MM-DD"),
            "end_date": moment(new Date(endDate)).format("YYYY-MM-DD"),
            "state": couponState,
            "stock": couponCount,
            "type": type,
            "usage_amount": usageAmount,
            "usage_period_day": usagePeriod,
            "target_sites": selectedEventSites.map((item) => item.value)
        };
        return data;
    };
    return (<React.Fragment>
            <div className="page-content">
                <div className="container-fluid" onChangeCapture={markDirty} onInputCapture={markDirty}>
                    <BreadCrumb title="쿠폰 등록 및 수정" pageTitle="쿠폰"/>

                    <div className="flex flex-wrap -mx-3 g-4 mb-3">
                        <div className="col-sm-auto px-3">
                            <div>
                                <h4 className="card-title mb-0 flex-grow-1">등록 및 수정</h4>
                            </div>
                        </div>
                        <div className="col-sm-3 ms-auto px-3">
                            <div className="d-flex justify-content-sm-end gap-2">
                                {(id !== '0') ?
            <Button onClick={updateData} id="create-btn" color="success" className="add-btn me-1">
                                            Update
                                        </Button> :
            <Button onClick={sendData} id="update-btn" color="success" className="add-btn me-1">
                                            Create
                                        </Button>}
                                <Button onClick={async () => {
                                    if (!await confirmDiscardChanges())
                                        return;
                                    navigate(`/couponbook-list`);
                                }} id="cancel-btn" color="danger" className="add-btn me-1">
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full xxl:w-full px-3">
                            <div className="card">
                                <div className="card-body">
                                    <div className="live-preview">
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="ForminputCouopnItem" className="form-label">대상 쿠폰</label>
                                                    <Select name="couponProducts" options={couponProducts} className="basic-select" classNamePrefix="select" onChange={(value) => {
            markDirty();
            setSelectedCouponProduct(value);
        }} value={selectedCouponProduct}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="ForminputState" className="form-label">쿠폰 상태</label>
                                                    <select value={couponState} onChange={(e) => (setCouponState(e.target.value))} id="ForminputState" className="form-select" data-choices data-choices-sorting="true">
                                                        <option key={0} value={"노출중"}>노출중</option>
                                                        <option key={1} value={"숨김"}>숨김</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label className="form-check-label" htmlFor="startDate">시작일</label>
                                                    <CommonDatePicker value={startDate} onChange={(value) => {
            markDirty();
            setStartDate(value);
        }} className="form-control" options={{
        }}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label className="form-check-label" htmlFor="endDate">종료일</label>
                                                    <CommonDatePicker value={endDate} onChange={(value) => {
            markDirty();
            setEndDate(value);
        }} className="form-control" options={{
        }}/>
                                                </div>
                                            </div>
                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="ForminputType" className="form-label">대상 사이트</label>
                                                    <Select name="eventSites" options={eventSites} className="basic-select" classNamePrefix="select" onChange={(value) => {
            markDirty();
            setSelectedEventSites([...(value || [])]);
        }} value={selectedEventSites} isMulti/>
                                                </div>
                                            </div>


                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label htmlFor="ForminputType" className="form-label">쿠폰 타입</label>
                                                    <select value={type} onChange={(e) => (setType(e.target.value))} id="ForminputType" className="form-select" data-choices data-choices-sorting="true">
                                                        <option key={0} value={"event"}>이벤트</option>
                                                        <option key={1} value={"new_join"}>신규 회원가입</option>
                                                        <option key={2} value={"membership"}>맴버십 회원</option>
                                                        <option key={3} value={"usage_amount"}>기간 사용금액</option>
                                                    </select>
                                                </div>
                                                {type === "usage_amount" ? <>
                                                    <div className="mb-3">
                                                        <label className="form-check-label" htmlFor="usageAmount">사용금액</label>
                                                        <input type="number" className="form-control" id="usageAmount" value={usageAmount} onChange={(e) => { setUsageAmount(e.target.value); }}/>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-check-label" htmlFor="usagePeriod">사용기간</label>
                                                        <input type="number" className="form-control" id="usagePeriod" value={usagePeriod} onChange={(e) => { setUsagePeriod(e.target.value); }}/>
                                                    </div>
                                                </> : null}
                                            </div>


                                            <div className="w-full md:w-6/12 px-3">
                                                <div className="mb-3">
                                                    <label className="form-check-label" htmlFor="couponCount">쿠폰 수량</label>
                                                    <input type="number" className="form-control" id="couponCount" value={couponCount} onChange={(e) => { setCouponCount(e.target.value); }}/>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Row>
            <Col xxl={12}>
                <Card>
                    <CardHeader>
                        <h4 className="card-title mb-0">상세정보</h4>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <textarea className="form-control" id="exampleFormControlTextarea5" rows="10" value={descript} onChange={(e) => { setDescript(e.target.value); }}></textarea>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row> */}
                </div>
            </div>
        </React.Fragment>);
};
export default CouponBookForm;
